import React from 'react';
import '../../../assets/css/ContentCards.css';
import pink from '../../../assets/images/Group pink.svg'

const cardData = [
  {
    id: 1,
    title: "From Recovery to Everyday",
    initialParagraph: "Your Bloom piece doesn’t end with your recovery. We can help you:",
    listItems: [
      "Remove medical features",
      "Refit it as a dress, tunic, or pants",
      "Make it your everyday symbol of strength",
      "Comfort-first design with soft linings that gently support pads or prosthetics"
    ],
    finalParagraph: "Available anytime, whether during or after recovery. Because Bloom is not just for healing. It’s for living."
  },
  {
    id: 2,
    title: "Pass the Bloom Forward",
    initialParagraph: "Once you’ve completed your recovery, your Bloom gown can comfort someone else. Choose to:",
    listItems: [
      "Gift it to another woman in need",
      "Let us redistribute it to someone who can’t afford it"
    ],
    finalParagraph: "We’ll take care of the rest. Because Bloom is not just a garment. It’s a story. A shared strength."
  }
];
const Icon = () => <img src={pink} alt="list icon" className="list-icon-img" />;

const ContentCards = () => {
  return (
    <div className="content-cards-section">
      <div className="content-cards-container">
        {cardData.map(card => (
          <div key={card.id} className="content-card">
            <h2 className="card-title">{card.title}</h2>
            <p className="card-paragraph">{card.initialParagraph}</p>
            <ul className="card-list">
              {card.listItems.map((item, index) => (
                <li key={index}>
                  <Icon />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <p className="card-paragraph">{card.finalParagraph}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContentCards;